var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Div } from "../03-base/Div";
export var Legenda = function (props) { return (React.createElement(Div, { className: "scl-h-text-align--center" }, props.items.map(function (item) { return (React.createElement(LegendaItem, { key: props.scope ? props.scope + item.label : item.label, onClick: item.onClick, inactive: item.inactive, color: item.color, label: item.label })); }))); };
var LegendaItem = /** @class */ (function (_super) {
    __extends(LegendaItem, _super);
    function LegendaItem(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.onShow = function (_evt) {
            _this.setState({
                hovering: true,
            });
        };
        _this.onHide = function (_evt) {
            _this.setState({
                hovering: false,
            });
        };
        _this.state = {
            hovering: false,
        };
        _this.onShow = _this.onShow.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }
    LegendaItem.prototype.render = function () {
        return (React.createElement("span", { className: "scl-h-no-select", style: {
                whiteSpace: "nowrap",
                marginRight: "15px",
                marginTop: "5px",
                display: "inline-block",
                cursor: this.props.onClick ? "pointer" : "auto",
            }, onClick: this.props.onClick, onMouseOver: this.props.onClick ? this.onShow : undefined, onMouseOut: this.props.onClick ? this.onHide : undefined },
            React.createElement("span", { style: {
                    transition: "opacity .3s ease, transform .3s ease",
                    borderRadius: "100%",
                    opacity: (this.props.inactive && !this.state.hovering ? .5 : 1),
                    transform: (this.props.inactive ? "scale(.25)" : "scale(1)"),
                    height: "20px",
                    width: "20px",
                    backgroundColor: this.props.color,
                    color: "#fff",
                    marginRight: "5px",
                    display: "inline-block",
                    verticalAlign: "middle",
                } }),
            React.createElement("span", { className: "scl-h-text--tiny" +
                    (this.props.inactive && !this.state.hovering ? " scl-h-text--greyed-out" : ""), style: {
                    display: "inline-block",
                } }, this.props.label)));
    };
    return LegendaItem;
}(React.Component));
export { LegendaItem };
